(() => {
  const root = document.querySelector('[data-gp-compare]');
  if (!root) return;
  const host = root.parentElement;
  const DATA = JSON.parse(host.querySelector('[data-cmp-specs]').textContent);
  const LIVE = JSON.parse(host.querySelector('[data-cmp-live]').textContent);
  const $ = (s) => root.querySelector(s);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const AXES = {
    padel: [
      { k: 'pw', lo: 'Control', hi: 'Power', note: 'How the racket wants to move the ball.' },
      { k: 'stf', lo: 'Soft', hi: 'Firm', note: 'How the racket feels when you hit the ball.' },
      { k: 'fg', lo: 'Precise', hi: 'Forgiving', note: "How much it helps when you don't hit the sweet spot cleanly." },
    ],
    pickleball: [
      { k: 'pw', lo: 'Touch', hi: 'Pop', note: 'How the paddle wants to move the ball.' },
      { k: 'stf', lo: 'Soft', hi: 'Fast', note: 'How the paddle feels off the face.' },
      { k: 'fg', lo: 'Precise', hi: 'Forgiving', note: "How much it helps when you don't hit the sweet spot cleanly." },
    ],
  };

  const params = new URL(location.href).searchParams;
  let sport = ['padel', 'pickleball'].includes(params.get('sport')) ? params.get('sport') : null; // no sport until the shopper picks one
  const pairs = {};
  let lastSet = 1;

  const models = (s) => DATA[s].models.filter((m) => LIVE[m.h]);
  const byH = (h) => models(sport).find((m) => m.h === h);
  function initPair(s) {
    const url = (params.get('m') || '').split(',').filter((h) => DATA[s].models.some((m) => m.h === h) && LIVE[h]);
    const def = DATA[s].default.filter((h) => LIVE[h]);
    const pick = (url.length ? url : def).slice(0, 2);
    if (pick.length === 1) {
      const base = models(s).find((m) => m.h === pick[0]);
      const pool = models(s).filter((m) => m.h !== pick[0]);
      const same = pool.filter((m) => (m.specs.Level || m.specs.Line) === (base.specs.Level || base.specs.Line));
      const far = (same.length ? same : pool).sort((x, y) => (Math.abs(y.r.pw - base.r.pw) + Math.abs(y.r.fg - base.r.fg)) - (Math.abs(x.r.pw - base.r.pw) + Math.abs(x.r.fg - base.r.fg)))[0];
      if (far) pick.push(far.h);
    }
    while (pick.length < 2) { const n = models(s).find((m) => !pick.includes(m.h)); if (!n) break; pick.push(n.h); }
    pairs[s] = pick;
  }
  initPair('padel'); initPair('pickleball');

  const splitTitle = (t) => { const i = t.indexOf(' by '); return i > 0 ? [t.slice(0, i), t.slice(i + 4)] : [t, '']; };
  const short = (t) => splitTitle(t)[0].replace(/\s*2027$/, '').replace(/^2026 Pickleball Paddle\s*/i, '');

  /* Sweet spot: placed inside the measured head box. Shape sets position and base size; forgiveness scales it. */
  function spot(m) {
    const g = m.geo; const sh = (m.specs.Shape || '').toLowerCase(); const fg = m.r.fg || 50;
    let cy, w, h;
    if (sport === 'padel') {
      if (sh === 'diamond') { cy = 0.34; w = 0.40; h = 0.30; }
      else if (sh === 'round') { cy = 0.50; w = 0.56; h = 0.46; }
      else { cy = 0.43; w = 0.48; h = 0.38; }
    } else {
      if (sh.startsWith('elongated')) { cy = 0.40; w = 0.50; h = 0.36; }
      else if (sh.startsWith('wide')) { cy = 0.47; w = 0.62; h = 0.42; }
      else { cy = 0.44; w = 0.56; h = 0.38; }
    }
    const k = 0.82 + (fg / 100) * 0.4;
    w *= k; h *= k;
    return { l: g.x + g.w * (0.5 - w / 2), t: g.y + g.h * (cy - h / 2), w: g.w * w, h: g.h * h, area: w * h };
  }
  const spotWords = (m) => {
    const s = spot(m).area; const sh = (m.specs.Shape || '').toLowerCase();
    const size = s > 0.24 ? 'Large' : s > 0.15 ? 'Medium' : 'Compact';
    const where = sport === 'padel' ? (sh === 'diamond' ? 'high on the face' : sh === 'round' ? 'centered' : 'mid-upper face') : (sh.startsWith('elongated') ? 'higher on the face' : 'centered');
    return `${size}, ${where}`;
  };

  function renderStrip() {
    const [a, b] = pairs[sport];
    $('[data-strip]').innerHTML = models(sport).map((m) => {
      const l = LIVE[m.h]; const slot = m.h === a ? 'a' : m.h === b ? 'b' : '';
      return `<button type="button" class="gp-cmp__tile${slot ? ` is-${slot}` : ''}" data-pick="${esc(m.h)}" role="option" aria-selected="${!!slot}">
        ${slot ? `<span class="gp-cmp__badge gp-cmp__badge--${slot}">${slot.toUpperCase()}</span>` : ''}
        <img src="${esc(l.thumb)}" alt="" width="120" height="120" loading="lazy">
        <span>${esc(short(l.title))}</span>
      </button>`;
    }).join('');
    const sel = $('[data-strip] .is-a');
    if (sel && !renderStrip.done) { renderStrip.done = true; const st = sel.parentElement, sr = st.getBoundingClientRect(), cr = sel.getBoundingClientRect(); if (cr.left < sr.left || cr.right > sr.right) st.scrollLeft += cr.left - sr.left - (sr.width - cr.width) / 2; }
  }

  function col(m, slot) {
    const l = LIVE[m.h]; const [name, by] = splitTitle(l.title); const s = spot(m);
    const clean = name.replace(/\s*2027$/, '').replace(/^2026 Pickleball Paddle\s*/i, '');
    const who = by ? `${by}'s ${sport === 'padel' ? 'racket' : 'paddle'}` : (sport === 'padel' ? `NOX ${(clean.match(/^(Pro Cup|Genius|Ventus|Equation)/) || ['2027'])[0]} line` : `NOX ${m.specs.Line || ''} line`);
    const stats = sport === 'padel'
      ? [['Shape', m.specs.Shape], ['Style', m.specs['Play style']], ['Level', m.specs.Level]]
      : [['Shape', m.specs.Shape], ['Core', m.specs.Thickness], ['Line', m.specs.Line]];
    const where = spotWords(m).split(', ');
    return `<article class="gp-cmp__col gp-cmp__col--${slot}">
      <a class="gp-cmp__photo" href="${esc(l.url)}" aria-label="${esc(l.title)}">
        <span class="gp-cmp__badge gp-cmp__badge--${slot}">${slot.toUpperCase()}</span>
        <img src="${esc(l.img)}" alt="${esc(l.title)}" width="700" height="700">
        <span class="gp-cmp__spot" style="left:${s.l}%;top:${s.t}%;width:${s.w}%;height:${s.h}%"></span>
        <span class="gp-cmp__spotcap"><i></i><span><b>Sweet spot</b> ${esc(where[0])}, ${esc(where[1] || '')}</span></span>
      </a>
      <div class="gp-cmp__info">
        <div class="gp-cmp__id"><h2 class="gp-cmp__name"><a href="${esc(l.url)}">${esc(clean)}</a></h2>
        <p class="gp-cmp__who">${esc(who)}</p></div>
        <dl class="gp-cmp__stats">${stats.map(([k, v]) => `<div><dt>${k}</dt><dd>${esc(v || '—')}</dd></div>`).join('')}</dl>
        <div class="gp-cmp__buy">
          <p class="gp-price${l.was ? ' gp-price--sale' : ''}"><span>${esc(l.price)}</span>${l.was ? `<s>${esc(l.was)}</s>` : ''}</p>
          <a class="gp-cmp__view" href="${esc(l.url)}">View<span aria-hidden="true"> →</span></a>
        </div>
      </div>
    </article>`;
  }

  function renderStage() {
    const [a, b] = pairs[sport].map(byH);
    $('[data-stage]').innerHTML = `<div class="gp-cmp__duo">${col(a, 'a')}<button type="button" class="gp-cmp__vs" data-swap aria-label="Swap A and B"><span>vs</span><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 7h11l-3-3M16 13H5l3 3" fill="none" stroke="currentColor" stroke-width="1.6"/></svg></button>${col(b, 'b')}</div>`;
    requestAnimationFrame(() => { root.querySelectorAll('.gp-cmp__spot').forEach((e) => e.classList.add('is-on')); equalize(); });
  }

  const PHRASE = {
    pw: { padel: ['is built for control', 'leans control', 'balances power and control', 'leans power', 'is built for power'],
          pickleball: ['is built for touch', 'leans touch', 'balances touch and pop', 'leans pop', 'is built for pop'] },
    stf: { padel: ['feels soft', 'feels on the soft side', 'feels medium', 'feels on the firm side', 'feels firm'],
           pickleball: ['feels soft', 'feels on the soft side', 'feels medium', 'feels on the fast side', 'feels fast'] },
    fg: { padel: ['rewards precise hitting', 'is on the precise side', 'is moderately forgiving', 'is forgiving', 'is very forgiving'] },
  };
  function reading(va, vb, ax) {
    const list = (PHRASE[ax.k][sport] || PHRASE[ax.k].padel);
    const word = (v) => list[v >= 70 ? 4 : v >= 56 ? 3 : v > 44 ? 2 : v > 30 ? 1 : 0];
    if (Math.abs(va - vb) < 6) return `<b class="gp-cmp__va">A</b> and <b class="gp-cmp__vb">B</b> are close here: both ${word(va).replace(/^is /, 'are ').replace(/^feels /, 'feel ').replace(/^rewards /, 'reward ').replace(/^leans /, 'lean ').replace(/^balances /, 'balance ')}.`;
    return `<b class="gp-cmp__va">A</b> ${word(va)}. <b class="gp-cmp__vb">B</b> ${word(vb)}.`;
  }

  // A and B read across: name blocks share a height, so the specs start on the same line.
  function equalize() {
    const ids = [...root.querySelectorAll('.gp-cmp__id')];
    ids.forEach((e) => { e.style.minHeight = ''; });
    const h = Math.max(...ids.map((e) => e.offsetHeight));
    ids.forEach((e) => { e.style.minHeight = `${h}px`; });
    const photo = root.querySelector('.gp-cmp__photo'); const vs = root.querySelector('.gp-cmp__vs');
    if (photo && vs) vs.style.top = `${photo.offsetHeight / 2}px`;
  }
  window.addEventListener('resize', () => requestAnimationFrame(equalize), { passive: true });

  function renderPlay() {
    const [a, b] = pairs[sport].map(byH);
    const pos = (v) => 4 + v * 0.92;
    $('[data-play]').innerHTML = `<h2 class="gp-h2">How they play</h2>` + AXES[sport].map((ax) => {
      const pa = pos(a.r[ax.k]); const pb = pos(b.r[ax.k]);
      const lo = Math.min(pa, pb); const hi = Math.max(pa, pb);
      return `<div class="gp-cmp__axis">
        <div class="gp-cmp__ends"><span>${ax.lo}</span><span>${ax.hi}</span></div>
        <div class="gp-cmp__track"><span class="gp-cmp__gap" style="left:${lo}%;width:${hi - lo}%"></span>
          ${Math.abs(pa - pb) < 4 ? `<span class="gp-cmp__dot gp-cmp__dot--ab" style="left:${(pa + pb) / 2}%"><i>A</i><i>B</i></span>` : `<span class="gp-cmp__dot gp-cmp__dot--a" style="left:${pa}%">A</span><span class="gp-cmp__dot gp-cmp__dot--b" style="left:${pb}%">B</span>`}</div>
        <p class="gp-cmp__read">${reading(a.r[ax.k], b.r[ax.k], ax)}</p>
        <p class="gp-cmp__note">${ax.note}</p>
      </div>`;
    }).join('') + `<p class="gp-cmp__src">NOX USA ratings, based on NOX's own heat map and specs.</p>`;
  }

  function renderVerdict() {
    const [a, b] = pairs[sport].map(byH);
    const A = `<b class="gp-cmp__va">${esc(short(LIVE[a.h].title))}</b>`; const B = `<b class="gp-cmp__vb">${esc(short(LIVE[b.h].title))}</b>`;
    const out = [];
    const shA = a.specs.Shape; const shB = b.specs.Shape;
    const shapeWhy = sport === 'padel'
      ? { Diamond: 'built for overhead power', Teardrop: 'a balance of power and control', Round: 'built for control and touch' }
      : { Elongated: 'extra reach and power', Hybrid: 'a balance of reach and sweet spot', 'Wide body': 'the biggest sweet spot' };
    if (shA === shB) out.push(`Both are ${shA.toLowerCase()} shapes, so the difference is in the materials and tuning.`);
    else out.push(`${A} is a ${shA.toLowerCase()} shape, ${shapeWhy[shA] || ''}. ${B} is a ${shB.toLowerCase()} shape, ${shapeWhy[shB] || ''}.`);
    const d = (k) => a.r[k] - b.r[k];
    if (Math.abs(d('pw')) >= 8) out.push(`${d('pw') > 0 ? A : B} hits harder; ${d('pw') > 0 ? B : A} gives you more ${sport === 'padel' ? 'control' : 'touch'}.`);
    if (Math.abs(d('fg')) >= 10) out.push(`${d('fg') > 0 ? A : B} is more forgiving on off-center hits, which helps if you're still building consistency.`);
    if (Math.abs(d('stf')) >= 10) out.push(`${d('stf') > 0 ? A : B} feels firmer and more direct; ${d('stf') > 0 ? B : A} is softer and easier on the arm.`);
    if (sport === 'padel' && a.specs.Level !== b.specs.Level) out.push(`${A} is made for ${a.specs.Level.toLowerCase()} players, ${B} for ${b.specs.Level.toLowerCase()} players.`);
    if (sport === 'pickleball' && a.specs.Thickness !== b.specs.Thickness) out.push(`${a.specs.Thickness} vs ${b.specs.Thickness}: the thinner core gives more pop, the thicker one more control and a softer feel.`);
    if (out.length === 1) out.push('On power, feel and forgiveness they play very close. Pick the one whose look and price suit you.');
    $('[data-verdict]').innerHTML = `<h2 class="gp-h2">The difference</h2><ul>${out.map((s) => `<li>${s}</li>`).join('')}</ul>
      <button type="button" class="gp-link gp-cmp__share" data-share>Share this match-up</button>`;
  }

  function renderSpecs() {
    const [a, b] = pairs[sport].map(byH);
    const rows = DATA[sport].rows.filter((r) => a.specs[r] || b.specs[r]);
    $('[data-specs]').innerHTML = `<table><thead><tr><th></th><th><span class="gp-cmp__badge gp-cmp__badge--a">A</span></th><th><span class="gp-cmp__badge gp-cmp__badge--b">B</span></th></tr></thead><tbody>${rows.map((r) => {
      const va = a.specs[r] || '—'; const vb = b.specs[r] || '—'; const diff = va !== vb;
      return `<tr${diff ? ' class="is-diff"' : ''}><th scope="row">${esc(r)}</th><td>${esc(va)}</td><td>${esc(vb)}</td></tr>`;
    }).join('')}</tbody></table><p class="gp-cmp__src">Specs from NOX. Rows that differ are highlighted.</p>`;
  }

  function sync() {
    const url = new URL(location.href);
    url.searchParams.set('sport', sport); url.searchParams.set('m', pairs[sport].join(','));
    history.replaceState(null, '', url);
  }
  function renderAll() {
    root.classList.toggle('is-pick', !sport);
    if (!sport) { $('[data-pickhint]').textContent = 'Choose padel or pickleball to start.'; return; }
    root.querySelectorAll('[data-sport]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.sport === sport)));
    $('[data-seg]').dataset.active = sport;
    $('[data-strip]').style.setProperty('--n', models(sport).length);
    $('[data-pickhint]').textContent = `Tap any ${sport === 'padel' ? 'racket' : 'paddle'} to put it in the match-up.`;
    root.querySelector('.gp-cmp__result-sub').textContent = `Tap another ${sport === 'padel' ? 'racket' : 'paddle'} above to swap it in.`;
    renderStrip(); renderStage(); renderPlay(); renderVerdict(); renderSpecs(); sync();
  }
  function update() { renderStrip(); renderStage(); renderPlay(); renderVerdict(); renderSpecs(); sync(); }

  root.addEventListener('click', (e) => {
    const s = e.target.closest('[data-sport]');
    if (s && s.dataset.sport !== sport) { sport = s.dataset.sport; renderStrip.done = false; renderAll(); return; }
    const p = e.target.closest('[data-pick]');
    if (p) {
      const h = p.dataset.pick; const pair = pairs[sport];
      if (pair.includes(h)) return;
      const slot = lastSet === 1 ? 0 : 1; pair[slot] = h; lastSet = slot;
      update();
      const stage = $('[data-stage]');
      if (stage.getBoundingClientRect().top > window.innerHeight * 0.6) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (e.target.closest('[data-swap]')) { pairs[sport].reverse(); update(); return; }
    const sh = e.target.closest('[data-share]');
    if (sh) {
      const url = location.href; const [a, b] = pairs[sport].map((h) => short(LIVE[h].title));
      const done = () => { sh.textContent = 'Link copied'; setTimeout(() => { sh.textContent = 'Share this match-up'; }, 1800); };
      if (navigator.share && matchMedia('(hover: none)').matches) navigator.share({ title: `${a} vs ${b}`, url }).catch(() => {});
      else if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, () => {});
    }
  });

  renderAll();
})();
